import { useAuthStore } from "@/features/auth"
import { NavigationGuardNext, type RouteLocationNormalized, type RouteLocationNormalizedLoaded } from "vue-router"

export async function checkAuthMiddleware(to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
    const authStore = useAuthStore()
    await authStore.init()

    if (to.meta.requiresAuth && !authStore.isAuthenticated)
        return next({ name: "Login" })

    else if (to.name === "Login" && authStore.isAuthenticated)
        return next({ path: "/" })

    next()
}
